import styled from 'styled-components';
export const FooterContainer = styled.footer `
  background: var(--bg-secondary);
  color: var(--text-primary);
  padding: 60px 0 20px;
  margin-top: auto;
  border-top: 1px solid var(--border-color);
  position: relative;
`;
export const FooterContent = styled.div `
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;
export const FooterSections = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;
export const FooterSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
export const FooterSectionTitle = styled.h3 `
  font-family: 'Playfair Display', 'Adamina', serif;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  position: relative;
  padding-bottom: 15px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 2px;
    background: var(--accent-gold, #B8860B);
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 60px;
  }
`;
export const FooterText = styled.p `
  font-family: 'DM Sans', 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0;
`;
export const FooterLinks = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const FooterLinkItem = styled.li ``;
export const FooterLink = styled.a `
  font-family: 'DM Sans', 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-secondary);
  text-decoration: none;
  transition: all 0.2s ease;
  display: inline-block;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1px;
    background: var(--accent-gold, #B8860B);
    transition: width 0.3s ease;
  }

  &:hover {
    color: var(--accent-gold, #B8860B);

    &::after {
      width: 100%;
    }
  }
`;
export const ContactInfo = styled.div `
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
export const ContactItem = styled.p `
  font-family: 'DM Sans', 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.6;

  a {
    color: var(--text-secondary);
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: var(--accent-gold, #B8860B);
    }
  }
`;
export const SocialLinks = styled.div `
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;
export const SocialLink = styled.a `
  font-family: 'DM Sans', 'Poppins', sans-serif;
  font-size: 13px;
  color: var(--text-secondary);
  text-decoration: none;
  transition: all 0.25s ease;
  position: relative;
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  display: inline-block;

  &:hover {
    color: var(--accent-gold, #B8860B);
    transform: translateY(-2px);
    border-color: var(--accent-gold, #B8860B);
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
  }
`;
export const FooterBottom = styled.div `
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid var(--border-color);
  text-align: center;
`;
export const CopyrightText = styled.p `
  font-family: 'DM Sans', 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: var(--text-tertiary);
  margin: 0;
  letter-spacing: 0.02em;
`;
